/**
 * `/auth/v1/*` — console sign-in against the Spoonity Identity Server
 * (CONTRACT §2.4). Field names are snake_case on purpose: the bodies are the
 * CMS's (`spoonity-cms` `/api/v1/auth/*`), so a client written for one works
 * against the other.
 */
import { z } from "zod";
import { adminRole } from "./admin.js";
import { slug } from "./common.js";
export const authLoginRequest = z
    .object({ email: z.string().min(1).max(320), password: z.string().min(1).max(320) })
    .strict();
export const authSelectVendorRequest = z
    .object({
    selection_token: z.string().min(1),
    vendor_id: z.union([slug, z.number().int()]),
})
    .strict();
export const authSwitchVendorRequest = z
    .object({ vendor_id: z.union([slug, z.number().int()]) })
    .strict();
/** One vendor the Identity Server says this person belongs to, with their mapped role. */
export const authVendor = z.object({ id: slug, name: z.string(), role: adminRole }).strict();
export const authUser = z
    .object({ id: z.string(), email: z.string(), name: z.string(), role: adminRole })
    .strict();
/** A finished sign-in: `select-vendor`, `switch-vendor`, and a one-vendor `login`. */
export const authSession = z
    .object({
    /** HS256 session JWT — the console's bearer for `/admin/v1`. */
    token: z.string(),
    expires_at: z.string(),
    vendor: z.object({ id: slug, name: z.string() }).strict(),
    user: authUser,
    allowed_vendors: z.array(authVendor),
})
    .strict();
export const authLoginComplete = authSession
    .extend({
    success: z.literal(true),
    requires_vendor_selection: z.literal(false),
    identities: z.array(authVendor),
})
    .strict();
export const authLoginSelect = z
    .object({
    success: z.literal(true),
    requires_vendor_selection: z.literal(true),
    /** 15-minute token scoped `select`; send it to `select-vendor`. */
    selection_token: z.string(),
    identities: z.array(authVendor),
})
    .strict();
export const authLoginResponse = z.union([authLoginComplete, authLoginSelect]);
export const authMe = z
    .object({
    user: authUser,
    vendor: z.object({ id: slug, name: z.string() }).strict(),
    allowed_vendors: z.array(authVendor),
    expires_at: z.string(),
})
    .strict();
//# sourceMappingURL=auth.js.map